




























































import Vue from 'vue'
import api from '@/api'
import SwitcherActive from '../../components/SwitcherActive.vue'
import SwitcherDisabled from '../../components/SwitcherDisabled.vue'

export default Vue.extend({
  data() {
    return {
      items: [] as any[],
      columns: [
        { label: 'Nom', field: 'name', searchable: true },
        { label: 'Représentant', field: 'representativeName' },
        { label: 'Siège', field: 'address', width: '150px' },
        { label: 'Adresse électronique', field: 'email' },
        { label: 'Téléphone', field: 'contact' },
        { label: 'Administrateur', field: 'admin.fullname' },
        { label: 'Actions', field: '_actions' }
      ]
    }
  },

  methods: {
    async load() {
      try {
        const response = await api.get('/organizations', {
          params: {
            type: 'sfd',
            select: '-balances,-kkiapayAccounts',
            populate: 'admin'
          }
        })
        this.items = (response.data || []).map((org: any) => {
          const admin = org.admin || {}
          return {
            ...org,
            id: org._id || org.id,
            admin: {
              ...admin,
              fullname: admin.firstname
                ? `${admin.lastname || ''} ${admin.firstname || ''}`.trim()
                : ''
            }
          }
        })
      } catch (error) {
        console.log(error) // eslint-disable-line
        ;(this as any).$notify.error(
          'Une erreur est survenue lors du chargement des SFD'
        )
      }
    },
    async activate(this: any, id: string) {
      try {
        await api.post(`/organizations/unblock-sfd-dispatching/${id}`)
        this.$notify.success('Le SFD a été activer avec succès')
        await this.load()
      } catch (error) {
        console.log(error) // eslint-disable-line
        this.$notify.error("Une erreur s'est produite.\n Veuillez réesayez")
      }
    },
    async desactivate(this: any, id: string) {
      try {
        await api.post(`/organizations/block-sfd-dispatching/${id}`)
        this.$notify.success('Le SFD a été désactiver avec succès')
        await this.load()
      } catch (error) {
        console.log(error) // eslint-disable-line
        this.$notify.error("Une erreur s'est produite.\n Veuillez réesayez")
      }
    }
  },

  created() {
    this.load()
  },
  components: { SwitcherActive, SwitcherDisabled }
})
